import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Legal.css'

export default function Terms() {
  useEffect(() => { document.title = 'Terms of Service — CommitHQ' }, [])

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to="/">&#8592; Back to CommitHQ</Link>
      </nav>
      <div className="legal-inner">
        <h1>Terms of Service</h1>
        <p className="legal-date">Last updated: April 8, 2025</p>

        <p>
          Welcome to CommitHQ. By accessing or using our service, you agree to
          be bound by these Terms of Service. Please read them carefully.
        </p>

        <h2>1. Use of the Service</h2>
        <p>
          CommitHQ provides tools to help baseball families manage the college
          recruiting process. You may use the service for lawful purposes only.
          You are responsible for all activity that occurs under your account.
        </p>

        <h2>2. Account Registration</h2>
        <p>
          You must provide accurate information when creating an account. You
          are responsible for maintaining the security of your password and for
          any activity that occurs under your account.
        </p>

        <h2>3. Athlete Profiles</h2>
        <p>
          When you create a public athlete profile, that profile is accessible
          to anyone with the link. Do not include sensitive personal information
          you would not want shared publicly (e.g., home address, phone numbers
          of minors).
        </p>

        <h2>4. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the service to harass, spam, or mislead coaches or other users</li>
          <li>Post false or misleading information about an athlete</li>
          <li>Attempt to gain unauthorized access to other accounts or our systems</li>
          <li>Use automated tools to scrape or bulk-collect data from the platform</li>
        </ul>

        <h2>5. Intellectual Property</h2>
        <p>
          CommitHQ and its content are owned by CommitHQ and protected by
          applicable intellectual property laws. You retain ownership of the
          content you submit, but grant CommitHQ a license to display and
          store it as necessary to provide the service.
        </p>

        <h2>6. Disclaimer of Warranties</h2>
        <p>
          The service is provided "as is" without warranties of any kind.
          CommitHQ does not guarantee any recruiting outcomes or coach
          responses resulting from use of the platform.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, CommitHQ shall not be liable
          for any indirect, incidental, or consequential damages arising from
          your use of the service.
        </p>

        <h2>8. Changes to These Terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the
          service after changes constitutes acceptance of the new terms.
        </p>

        <h2>9. Contact</h2>
        <p>
          Questions about these terms? Email us at{' '}
          <a href="mailto:support@commithq.com">support@commithq.com</a>.
        </p>
      </div>
    </div>
  )
}
